var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "md-layout md-gutter md-alignment-top-center" }, [
      _c(
        "div",
        {
          staticClass:
            "\n        md-layout-item\n        md-size-10\n        md-medium-size-10\n        md-small-size-10\n        md-xsmall-size-0\n      "
        },
        [
          _c(
            "md-button",
            {
              staticClass: "md-fab",
              on: {
                click: function($event) {
                  return _vm.goBack()
                }
              }
            },
            [_c("md-icon", [_vm._v("arrow_back")])],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "\n        md-layout-item\n        md-size-80\n        md-medium-size-80\n        md-small-size-80\n        md-xsmall-size-100\n      "
        },
        [
          _c(
            "md-card",
            { staticClass: "md-alignment-top-center md-elevation-1" },
            [
              _c("md-card-header", [
                _c("div", { staticClass: "md-title md-accent" }, [
                  _c("h2", [_vm._v("Suche nach Referenzprojekten")])
                ])
              ]),
              _vm._v(" "),
              _c(
                "md-card-content",
                [
                  _c(
                    "md-field",
                    [
                      _c("label", [_vm._v("Suchbegriffe")]),
                      _vm._v(" "),
                      _c("md-input", {
                        model: {
                          value: _vm.searchterm,
                          callback: function($$v) {
                            _vm.searchterm = $$v
                          },
                          expression: "searchterm"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm._l(_vm.searchresults, function(item) {
            return _c(
              "div",
              { key: item.name },
              [
                _c(
                  "router-link",
                  {
                    staticClass: "no-link",
                    attrs: {
                      to: {
                        name: "ReferenceProjectDetail",
                        params: { hash: item.hash }
                      }
                    }
                  },
                  [
                    _c(
                      "md-card",
                      {
                        staticClass:
                          "margin-twenty md-alignment-top-center md-elevation-1",
                        attrs: { "md-with-hover": "" }
                      },
                      [
                        _c(
                          "md-card-header",
                          { staticClass: "md-title" },
                          [
                            _c("md-card-header-text", [
                              _vm._v(_vm._s(item.name))
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("md-card-content", [
                          _c(
                            "div",
                            {
                              staticClass:
                                "md-layout md-gutter md-alignment-top-center"
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "\n                    md-layout-item\n                    md-size-80\n                    md-medium-size-70\n                    md-small-size-60\n                    md-xsmall-size-100\n                  "
                                },
                                [
                                  _c("p", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.shorten(item.description)
                                      )
                                    }
                                  })
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "\n                    md-layout-item\n                    md-size-20\n                    md-medium-size-30\n                    md-small-size-40\n                    md-xsmall-size-100\n                  "
                                },
                                [
                                  item.imagelink != "undefined"
                                    ? _c("img", {
                                        attrs: {
                                          "item.imagelink": "",
                                          src:
                                            "/static/uploads/" + item.imageLink
                                        },
                                        on: { error: _vm.setAltImg }
                                      })
                                    : _vm._e()
                                ]
                              )
                            ]
                          )
                        ])
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          })
        ],
        2
      ),
      _vm._v(" "),
      _c("div", {
        staticClass:
          "\n        md-layout-item\n        md-size-10\n        md-medium-size-10\n        md-small-size-10\n        md-xsmall-size-0\n      "
      })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a31fa742", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a31fa742","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/search/referenceprojectsearch/query/ReferenceProjectSearch.vue
// module id = null
// module chunks = 